import * as React from "react";
import { TextArea as Area, useFieldState, FieldProps, useFieldApi } from "informed";
import * as classNames from 'classnames';
import { inputClasses } from "../validation/ValidationClasses";

interface TextAreaProps<V, VS> extends FieldProps<V, VS> {
    field: string;
    inputAddon?: React.ReactNode;
}
export const TextArea = <V, VS>({ field, inputAddon, ...props }: TextAreaProps<V, VS>) => {
    const fieldState = useFieldState(field);
    const fieldApi = useFieldApi(field);

    const divClasses = classNames({ "input-group": inputAddon !== undefined })

    return (
        <>
            <div className={divClasses}>
                <Area<V, VS>
                    field={field}
                    className={inputClasses(fieldApi.getError())}
                    {...props}
                />
                {inputAddon ? <span className="input-group-addon">{inputAddon}</span> : null}
            </div>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError()}</span> : null}
        </>
    );
}
